var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import assign from 'lodash/assign';
import entries from 'lodash/entries';
import mapKeys from 'lodash/mapKeys';
import omitBy from 'lodash/omitBy';
import pickBy from 'lodash/pickBy';
import querystring from 'querystring';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { billScreenColumns } from '../Auth/screens/Bills';
import { bookingScreenColumns } from '../Auth/screens/Bookings';
import { paymentScreenColumns } from '../Auth/screens/Payments';
import { hyphenToCamelCase, normalizeStringToArray, stripFilterPrefix } from '../helpers';
import { setOptions, updateFilters } from '../store/actions';
import { connect } from '../store/connect';
import { getFilterColumns } from './Courses/courses-helpers';
import { useCampaignName } from './useCampaignName';
var filterColumns = function (dirtyColumns, availableColumns) {
    var availableColumnNames = availableColumns.map(function (column) { return column.key; });
    var defaultColumns = availableColumns.map(function (column) { return column.visible !== false && column.key; }).filter(Boolean);
    return !dirtyColumns.length
        ? defaultColumns
        : dirtyColumns.map(function (dirtyColumn) { return dirtyColumn.toLowerCase(); }).filter(function (column) { return availableColumnNames.includes(column); });
};
var componenetFactory = function () {
    var Component = function (props) {
        var search = useLocation().search;
        var cleanQsList = React.useMemo(function () { return mapKeys(querystring.parse(search.substring(1)), function (value, key) { return hyphenToCamelCase(key); }); }, [search]);
        var Component = props.Component, allAttributes = props.attributes, filterPrefix = props.filterPrefix, updateFilters = props.updateFilters, setOptions = props.setOptions, componentProps = __rest(props, ["Component", "attributes", "filterPrefix", "updateFilters", "setOptions"]);
        var _a = assign({}, allAttributes, cleanQsList), label = _a.label, showWizard = _a.showWizard, _b = _a.filters, filters = _b === void 0 ? null : _b, searchParams = _a.searchParams, _c = _a.perpage, perpage = _c === void 0 ? '10' : _c, campaign_name = _a.campaign_name, cn = _a.cn, campaign = _a.campaign, _d = _a.page, page = _d === void 0 ? '1' : _d, disableinfo = _a.disableinfo, _e = _a.columns, columns = _e === void 0 ? '' : _e, _f = _a.fixedColumns, fixedColumns = _f === void 0 ? '' : _f, showSearchFilter = _a.showSearchFilter, _g = _a.authEntities, authEntities = _g === void 0 ? '' : _g, _h = _a.userBillsColumns, userBillsColumns = _h === void 0 ? '' : _h, _j = _a.userBookingsColumns, userBookingsColumns = _j === void 0 ? '' : _j, _k = _a.userPaymentsColumns, userPaymentsColumns = _k === void 0 ? '' : _k, _l = _a.authMode, authMode = _l === void 0 ? "tabs" : _l, flattenedFilters = __rest(_a, ["label", "showWizard", "filters", "searchParams", "perpage", "campaign_name", "cn", "campaign", "page", "disableinfo", "columns", "fixedColumns", "showSearchFilter", "authEntities", "userBillsColumns", "userBookingsColumns", "userPaymentsColumns", "authMode"]);
        var disabledFilters = pickBy(flattenedFilters, function (x, key) { return key.includes('disablefilter'); });
        var appliedFilters = omitBy(flattenedFilters, function (x, key) { return key.includes('disablefilter'); });
        var mergedFilters = omitBy(appliedFilters, function (value, key) {
            return !value || appliedFilters[filterPrefix + key] || (key.includes('wsc') && !key.includes(filterPrefix));
        });
        var _m = stripFilterPrefix(mergedFilters), integrationName = _m.integrationName, courses = _m.courses, places = _m.places, months = _m.months, searchProp = _m.search, serverFilters = __rest(_m, ["integrationName", "courses", "places", "months", "search"]);
        var allowedFilters = filters !== null && filters.trim() === ''
            ? []
            : getFilterColumns(normalizeStringToArray(filters || ''), disabledFilters);
        var options = {
            pageSize: +perpage,
            pageNumber: +page,
            disableInfo: !!disableinfo,
            hasServerFilters: !!serverFilters.fcourses,
            additionalProps: serverFilters,
            allowedFilters: allowedFilters,
            columns: columns,
            fixedColumns: fixedColumns,
            authEntities: authEntities,
            userBillsColumns: userBillsColumns,
            userBookingsColumns: userBookingsColumns,
            userPaymentsColumns: userPaymentsColumns,
            authMode: authMode,
            showSearchFilterAfter: isNaN(showSearchFilter) ? showSearchFilter === 'true' ? -1 : Infinity : +showSearchFilter,
        };
        var uiFilters = entries({ courses: courses, places: places, months: months, search: searchProp }).reduce(function (filtersHash, _a) {
            var key = _a[0], value = _a[1];
            var isAllowedFilter = allowedFilters.includes(key);
            filtersHash[key] = isAllowedFilter && value ? value.split(',') : [];
            return filtersHash;
        }, {});
        var finalProps = __assign({ attributes: uiFilters, filterPrefix: filterPrefix, searchParams: searchParams }, componentProps);
        var criteria = querystring.stringify(serverFilters);
        useCampaignName();
        useEffect(function () {
            updateFilters(criteria);
        }, [criteria]);
        useEffect(function () {
            setOptions(__assign(__assign({}, options), { columns: normalizeStringToArray(columns), fixedColumns: normalizeStringToArray(fixedColumns), authEntities: normalizeStringToArray(authEntities).map(function (entity) { return entity.toLowerCase(); }), userBillsColumns: filterColumns(normalizeStringToArray(userBillsColumns), billScreenColumns), userBookingsColumns: filterColumns(normalizeStringToArray(userBookingsColumns), bookingScreenColumns), userPaymentsColumns: filterColumns(normalizeStringToArray(userPaymentsColumns), paymentScreenColumns) }));
        }, [JSON.stringify(options)]);
        var renderComponent = function (props) { return React.createElement(Component, __assign({}, props)); };
        if (!props.hasOptions || (props.queryString || '') !== criteria)
            return null;
        return renderComponent(finalProps);
    };
    var mapStateToProps = function (state) {
        var queryString = (state.appReducer || {}).queryString;
        return {
            queryString: queryString,
            hasOptions: state.courseReducer.hasOptions
        };
    };
    return connect(mapStateToProps, { updateFilters: updateFilters, setOptions: setOptions })(Component);
};
export var AppBootstrapComponent = componenetFactory();
